// extracted by mini-css-extract-plugin
module.exports = {"category_button":"ProductSlider_category_button__2oqrt"};